'use strict';
import TaiForm from "./components/Form.component.js";

window["TaiForm"] = TaiForm;
if (window.top !== window.self) {
    document.documentElement.classList.add('tai-in-iframe');
}


export { TaiForm }

